import type { CSSProperties, ReactNode } from 'react';
import { DS2 } from '../../theme/designTokens';

/** Gold-gradient clipped text style — spread onto any element's `style`. */
export const gradientTextStyle: CSSProperties = {
  background:           DS2.gradient.gold,
  color:                'transparent',
  WebkitBackgroundClip: 'text',
  backgroundClip:       'text',
};

interface Props {
  children: ReactNode;
  style?:   CSSProperties;
}

/** Inline span with the DS2 gold-gradient text treatment. */
export function GradientText({ children, style }: Props) {
  return <span style={{ ...gradientTextStyle, ...style }}>{children}</span>;
}
